// @core/api/endpoints/affiliate/get_commission_tier.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CommissionTierResponse,
} from '../../../types/affiliate';

const BASE_PATH = '/affiliate';

/**
 * Get commission tier by ID
 * Retrieves commission tier by the specified identifier.
 */
export async function GetCommissionTier(
  tier_id: string,
  options?: RequestOptions
): Promise<CommissionTierResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/commission-tiers/:tier_id`;
  requestPath = requestPath.replace(':tier_id', encodeURIComponent(tier_id));
  const requestOptions = options;
  return client.get<CommissionTierResponse>(requestPath, { ...requestOptions });
}
